<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Multiselect from "@vueform/multiselect";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import {getBaseUrl} from "@/helpers/baseUrl";



export default {


  components: {
    Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager, DxFilterRow, DxRemoteOperations,
    Loader, Multiselect

  },
  data() {

    return {
      title: "Impressoras",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Impressoras",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      showModalImpressora: false,
      submittedImpressora: false,
      impressoraData: {},
      dtListPesqUsuario: null

    };
  },

  created() {

  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {


    pesqUsuario(evt) {
      console.log('pesqUsuario')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/userpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqUsuario = res.data
        });
      }
    },


    novaImpressora() {
      console.log('novaImpressora')
      this.submittedImpressora = false
      this.showModalImpressora = true


    },


    confImpressora() {
      console.log('confImpressora')
      this.submittedImpressora = true

      if (this.impressoraData.descricao && this.impressoraData.canal && this.impressoraData.tag
        && this.impressoraData.user_id) {
        this.showModalImpressora = false
        api.post(`${getBaseUrl()}api/impressora`, {
          impressoraData: this.impressoraData
        }).then((res) => {
          console.log('res post impressora')
          console.log(res)

          this.atualizaDataList()
        })
      }

    },


    carregouGrid(e) {
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Impressoras'
    },


    atualizaDataList() {
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)


      this.dataList = new CustomStore({
        key: "id",
        load: function (loadOptions) {


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/impressoras`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
      this.impressoraData = row.data

      this.dtListPesqUsuario = [
        {
          'id': this.impressoraData.user_id,
          'name': this.impressoraData.usuario
        }
      ]

      this.showModalImpressora = true
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.movmeli_status)
          const valStatus = e.data.movmeli_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        } else if (e.column.dataField === "movmeli_etiq") {
          // console.log('onCellPrepared')
          // console.log(e.data.movmeli_status)
          const valStatus = e.data.movmeli_etiq
          let corStatus = 'rgba(78,59,0,0.5)'
          if (valStatus > 0) {
            corStatus = 'rgba(33,78,0,0.5)'
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e) {
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return 0.00;
    },

    nomeCanal(e) {
      switch (e.value) {
        case 'PU':
          return 'Pusher'

      }
      return 'Não Definido'
    },



    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },

    downloadJSON(data) {
      const jsonString = JSON.stringify(data, null, 2);
      const link = document.createElement('a');
      link.href = 'data:application/json;charset=utf-8,' + encodeURIComponent(jsonString);
      link.download = 'config.json';
      link.click();
      document.body.removeChild(link);
    },

    onSelectionChanged(e) {
      // Opcional: Gerenciar alterações de seleção em tempo real
      this.selectedItems = e.selectedRowKeys;
      // console.log(this.selectedItems)
    },

    sendSelectedRows() {
      // console.log('selectedRows')
      let ids = this.selectedItems
      ids.forEach(id => {
        // console.log(id)
        api.post(`${getBaseUrl()}api/getuserimpressoras/`, {
          params: {
            'ids': id
          }
        }).then(response => {
          console.log('response.data');
          console.log(response.data);

          const data = response.data;
          this.downloadJSON(data);
        })

      })
    },
    baixarAplicacao() {
      // Redireciona o usuário para o link do Google Drive
      window.open('https://drive.google.com/file/d/181qi8RiABf4Loy8NeccKnxET1z-mMuJL/view?usp=drive_link', '_blank')
    },
  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <DxToolbar>

        <DxItem location="before" widget="dxButton">
          <DxButton icon="refresh" hint="Redefinir formatação de tabela para padrão" :on-click="refeFormTable" />
        </DxItem>

        <DxItem location="before" widget="dxButton">

          <DxButton icon="plus" hint="Adicionar configuração para impressão" text="Nova Impressora"
            :on-click="novaImpressora" style="margin-right: 8px" />

          <DxButton text="Baixar aplicação" hint="Baixar aplicação da impressora" type="default" icon="download"
            @click="baixarAplicacao" style="margin-right: 8px" />
          <DxButton text="Baixar configuração" hint="Baixar configuração da aplicação" type="success" icon="preferences"
            @click="sendSelectedRows" style="margin-right: 8px" />

        </DxItem>

        <!--        <DxItem-->
        <!--            location="before"-->
        <!--            widget="dxButton">-->
        <!--          <DxButton-->
        <!--              icon="plus"-->
        <!--              hint="Importar arquivo de movimento"-->
        <!--              text="Novo Movimento"-->
        <!--              :on-click="novoMov"/>-->
        <!--        </DxItem>-->




      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid ref="dataGridRefKey" :data-source="dataList" :show-borders="true" :focused-row-enabled="true"
        :column-auto-width="true" :show-row-lines="true" :allow-column-reordering="true" :allow-column-resizing="true"
        :row-alternation-enabled="true" @cell-prepared="onCellPrepared" @row-dbl-click="onRowDblClick"
        @content-ready="carregouGrid" @exporting="onExporting" @selectionChanged=onSelectionChanged>

        <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" :summary="true" :grouping="false"
          :group-paging="false" />


        <DxColumnChooser :enabled="true" />
        <DxColumnFixing :enabled="true" />
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple" />
        <DxExport :enabled="true" :allow-export-selected-data="true" />
        <DxStateStoring :enabled="true" type="sessionStorage" storage-key="strImpressorasList" />

        <DxGroupPanel :visible="true" />
        <DxGrouping />



        <DxColumn data-field="id" sort-order="desc" caption="ID" data-type="number" alignment="right"
          :filter-operations="['=', '<>', '<', '>', '<=', '>=']" :allowHeaderFiltering="true" />


        <DxColumn data-field="descricao" caption="Descrição" data-type="text" alignment="left"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="true" />


        <DxColumn data-field="canal" caption="Canal" alignment="left" data-type="text" :customize-text="nomeCanal"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="true" />

        <DxColumn data-field="status" caption="Status" alignment="left" data-type="text" :customize-text="nomeStatus"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="false" />


        <DxColumn data-field="usuario" caption="Usuário" data-type="text" alignment="left"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="false" />


        <DxColumn data-field="created_at" caption="Criado" alignment="right" data-type="datetime"
          :filter-operations="['=', '<>', '<', '>', '<=', '>=']" :allowHeaderFiltering="true" />





        <DxPager :visible="true" :show-page-size-selector="true" :allowed-page-sizes="[10, 30, 50, 100]"
          :show-navigation-buttons="true" :show-info="true" />


      </DxDataGrid>


    </div>


    <b-modal size="xl"
      :title="impressoraData.id > 0 ? `Editar Impressora (${impressoraData.id})` : 'Criando nova Impressora'"
      v-model="showModalImpressora" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row">


            <div class="col-md-4">
              <label for="descricao">Descrição</label>
              <div class="position-relative">
                <input id="descricao" type="text" v-model="impressoraData.descricao" class="form-control"
                  placeholder="Descrição da impressora"
                  :class="{ 'is-invalid': submittedImpressora && !impressoraData.descricao }" />
                <div v-if="submittedImpressora && !impressoraData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="canal">Canal</label>
                <select id="canal" v-model="impressoraData.canal" class="form-control"
                  :class="{ 'is-invalid': submittedImpressora && !impressoraData.canal }">
                  <option value="PU">Pusher</option>
                </select>
                <div v-if="submittedImpressora && !impressoraData.canal" class="invalid-feedback">
                  <span>Campo canal obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <label for="tag">Tag</label>
              <div class="position-relative">
                <input id="tag" type="text" v-model="impressoraData.tag" class="form-control" placeholder="Tag"
                  :class="{ 'is-invalid': submittedImpressora && !impressoraData.tag }" />
                <div v-if="submittedImpressora && !impressoraData.tag" class="invalid-feedback">
                  <span>Campo Tag obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>



          </div>


          <div class="row">

            <div class="col-md-4">
              <div class="mb-3">
                <span class="font-size-13">Usuário</span>
                <multiselect id="inputUsuario" @search-change="pesqUsuario" v-model="impressoraData.user_id"
                  placeholder="pesquisar usuário..." :options="dtListPesqUsuario" :searchable="true" label="name"
                  track-by="name" value-prop="id"
                  :style="submittedImpressora && !impressoraData.user_id ? 'border: 1px solid #f86c6b !important;' : ''"
                  class="mt-2">
                  <template #option="slotProps">
                    <div style="min-width: 10%;">
                      <span class="text-info">
                        {{ slotProps.option.id }}
                      </span>
                    </div>
                    <div style="min-width: 250px;">
                      <span class="mx-4">
                        {{ slotProps.option.name }}
                      </span>

                      <span class="mx-4">
                        {{ slotProps.option.tipo }}
                      </span>
                    </div>
                  </template>
                </multiselect>
                <div v-if="submittedImpressora && !impressoraData.user_id">
                  <span class="text-danger font-size-11">Campo usuário obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>



          </div>

        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImpressora = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImpressora">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



  </Layout>
</template>
